import { render } from "./TriadSelectComponent.vue?vue&type=template&id=616ed157&scoped=true"
import script from "./TriadSelectComponent.vue?vue&type=script&lang=js"
export * from "./TriadSelectComponent.vue?vue&type=script&lang=js"

import "./TriadSelectComponent.vue?vue&type=style&index=0&id=616ed157&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616ed157"]])

export default __exports__